module.exports = "pegasus/assets/circleline-linkedin.gif";